import { render, staticRenderFns } from "./ResultsAuthorization.vue?vue&type=template&id=249568d2"
import script from "./ResultsAuthorization.vue?vue&type=script&lang=js"
export * from "./ResultsAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports